import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.806 14.765 1.235.194A.737.737 0 0 0 .194 1.235l14.571 14.571a.737.737 0 0 0 1.041-1.041" />
    <path d="M1.235 15.806 15.806 1.235A.737.737 0 0 0 14.765.194L.194 14.765a.737.737 0 0 0 1.041 1.041" />
  </svg>
);
const SvgCloseX = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="close-x" {...props} />;
export default SvgCloseX;
